import '.d{display:flex;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.a2{gap:0.5rem;}.ssr-plugin'
import '.ae{cursor:pointer;}.ssr-plugin'
import '.fx{padding:0.75rem;}.ssr-plugin'
import '.aw{border-radius:1.25rem;}.ssr-plugin'
import '.a9{border:var(--border-subtle);}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.dm{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fc{width:2.5rem;}.ssr-plugin'
import '.de{height:2.5rem;}.ssr-plugin'
import '.gi{color:var(--palette-blue-700);}.ssr-plugin'
import '.gj{font-size:0.9rem;}.ssr-plugin'
import '.s{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d z e y a2 ae fx aw a9 a8 dm"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fc de d y z gi"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="gj gi s"
        >
          {label}
        </span>
      </styled.button>
    )
}